import fetcher from '../../modules/ajio-fetch';
import endpoints from '../../modules/ajio-util/endpoints';
import { fetchGetJSONResHandler, fetchGetJSONReqOpts } from '../../modules/ajio-util/jsonUtils';


// constants for actionTypes
const ADD_STEP = 'ADD_STEP';
const REMOVE_STEP = 'REMOVE_STEP';
const START_ALL_STEPS = 'START_ALL_STEPS';


const DRESS_TOOL_API_CALL = 'DRESS_TOOL_API_CALL';

const DRESS_TOOL_INITIATE_INITIAL_FLAG = 'DRESS_TOOL_INITIATE_INITIAL_FLAG';
const DRESS_TOOL_INITIATE_FINAL_FLAG = 'DRESS_TOOL_INITIATE_FINAL_FLAG';
const DRESS_TOOL_CLOSE_FLAG = 'DRESS_TOOL_CLOSE_FLAG';
const ATC_DRESS_TOOL_INITIATE = 'ATC_DRESS_TOOL_INITIATE'
const DRESS_TOOL_WITHOUT_FIRST = 'DRESS_TOOL_WITHOUT_FIRST'

// actions
export const addStep = (stepData) => ({                             //adding step data for each step in bra recommendation module
  type: ADD_STEP,
  newItem: stepData,
});

export const removeStep = () => ({                                  //back button and remove last seleted data
  type: REMOVE_STEP,
});

export const startAllSteps = (retakeFlag) => ({                     //retake functionality
  type: START_ALL_STEPS,
});

export const dressToolAPICall = (apiCallData) => ({
  type: DRESS_TOOL_API_CALL,
  apiCallData
});


export const dressToolInitiateInitialFlag = () => ({                //for initiating dresstool and in other case removing final page and initiating initial page
  type: DRESS_TOOL_INITIATE_INITIAL_FLAG,
});

export const dressToolInitiateFinalFlag = (dressToolData) => ({     //for removing initial page and initiating final page
  type: DRESS_TOOL_INITIATE_FINAL_FLAG,
  dressToolData
});

export const dressToolCloseFlag = () => ({                          //close all pages
  type: DRESS_TOOL_CLOSE_FLAG,
});

export const atcDressToolInitiate = () => ({                //for triggering dress tool from atc for mobile
  type: ATC_DRESS_TOOL_INITIATE,
});

export const dressToolWithoutFirstStep = () => ({                //for removing final page and initiating second page
  type: DRESS_TOOL_WITHOUT_FIRST,
});


function parseJsonResponse(jsonString) {
  try {
    return JSON.parse(jsonString);
  } catch (error) {
    console.error('Error parsing JSON:', error.message);
    return null;
  }
}

export function fetchDressToolApiData() {
  return async function(dispatch,getState) {
    const state = getState();
    if(state?.apiCallReducer?.dressToolApiCall?.questions?.length){             //do not recall API for data logic
      return;
    }
    const apiEndPoint = `/api/home/dressTool`;
    return fetcher(
      apiEndPoint,
      fetchGetJSONReqOpts({
        method: 'GET',
        headers: { 'content-type': 'application/json' }
      })
    )
      .then(fetchGetJSONResHandler)
      .then(response => {
        const json = response.data?.component?.banners?.[0]?.staticContent;
        if (json) {
          const data = parseJsonResponse(json);
          dispatch(dressToolAPICall(data));
        } else {
          throw new Error('API response is invalid');
        }
      })
      .catch(error => {
        console.error('Error fetching data:', error);
      });
  };
}